export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'list',
		label: 'List',
		selector: '& ul'
	},
	{
		name: 'title',
		label: 'Title',
		selector: '& .title'
	},
	{
		name: 'description',
		label: 'Description',
		selector: '& .description'
	}
]